import { styled } from '@withjoy/joykit';
import { InterFonts } from '@shared/utils/fonts/interFonts';

export const MainText = styled.p`
  ${InterFonts.title}
  margin-top: 24px;
`;
